import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emailMask',
})
export class EmailMaskPipe implements PipeTransform {
  transform(email: string): string {
    const parts = email.split('@');
    if (parts.length === 2) {
      const username = parts[0];
      const domain = parts[1];
      const maskedUsername = username.substring(0, 2) + '********';
      return maskedUsername + '@' + domain;
    } else {
      return email;
    }
  }
}
